import dayjs from "dayjs";
import { IGetReportContaPagarUseCase } from "../../../presentation/useCases/read/get_report_conta_pagar_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";
import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";

/**
 * GetReportContaPagarUseCase
 */

export class GetReportContaPagarUseCase implements IGetReportContaPagarUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async execute(idContasPagar: number, requiredMimeType: ReportMimeType | null): Promise<ReportData> {
    const response = await this.repository.getReportContaPagar(idContasPagar, requiredMimeType ?? "text/html");

    if (response.mimeType !== "text/html") {
      const arquivoData = response.bytes;
      const arquivoNome = idContasPagar === null
        ? `contas_pagar_lista_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`
        : `conta_pagar_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;

      await downloadBase64File(arquivoNome, arquivoData);
    }

    return response;

  }
}
